export interface BookGuestDto {
  full_name?: string;
  birthday?: string;
}

export const isGuestInfoExists = (guestInfo?: BookGuestDto): boolean => {
  return !!guestInfo && Object.values(guestInfo).some(Boolean);
};
